import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ToastMsg from "../../../../../../src/helper/ToastMsg";
import PersonalLoan from "../../../../../Images/NewUI/personalloan.png";
import imageSomeTime from "../../../../../Images/Personalnew.webp";
import imageArrow from "../../../../../Images/greenarrow.png";
import { notifyVisitorEvent } from "../../../../../Redux/ApplyLoan/action";
import { getBlockedSections, checkBlockedEligibility, cibilPullOnReeligibility } from "../../../../../Redux/GeneralDetails/action";
import { CreditAssist, fetchProductsUrl } from "../../../../../Redux/Manual_Kyc_Details/action";
import After90DaysLoanReject from "./After90DaysLoanReject";
import LoanRejectZet from "./LoanRejectZet";


const LoanReject = (props) => {
  const [caBtnName, setCaBtnName] = useState("");
  const [blockedImage, setBlockedImage] = useState(null);
  const [blockedData, setBlockedData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isEligible, setIsEligible] = useState(false); 

  useEffect(() => {
    const token = props?.user?.User?.token || localStorage.getItem("gpay_token");
   props.checkBlockedEligibility(token)
        .then((res) => {
          const eligible = res?.data?.eligible;
          setIsEligible(eligible);
          if (!eligible) {
            handleBlockedSections(token);
          } else {
            setIsLoading(false);
          }
        })
        .catch(() => {
          handleBlockedSections(token);
        });
  }, []);

  const handleBlockedSections = (token) => {
    props.getBlockedSections(token)
      .then((res) => {
        const data = res?.data?.data?.[0];
        console.log("Blocked Section Response:", res);

        if (data?.image) {
          setBlockedImage(data.image);
          setBlockedData(data);
        } else {
          setIsLoading(false); 
        }
      })
      .catch((err) => {
        console.log("Blocked Section API Error:", err.response); 
        setIsLoading(false); 

        if (err.response?.status === 401) {
          localStorage.removeItem("gpay_token");
          window.location.href = "/";
        } else {
          ToastMsg(err?.response?.data?.error || "Failed to load blocked section", "error");
        }
      });
  };

  const handleImageLoad = () => {
    console.log("Image loaded successfully!");
    setIsLoading(false);  
  };

  const handleImageError = () => {
    console.error("Image failed to load!");
    setIsLoading(false); 
    setBlockedImage(null); 
    ToastMsg("Failed to load image.", "error"); 
  };

  const handleBlockedImageClick = () => {
    if (!blockedData) return;

   

    let token = props.token || localStorage.getItem("gpay_token");

    props.fetchProductsUrl(token, blockedData.key)
      .then((res) => {
        setTimeout(() => {
          window.open(res.data.url, "_blank");
        }, 100);
      })
      .catch((err) => {
        console.error(err);
      });
  };

 

  return (
    <div>
      {isLoading && <div className="skeleton-loader" />}

      {isEligible ? (
        <After90DaysLoanReject onCheckNow={props.cibilPullOnReeligibility} />
      ) : blockedImage ? (
        <div className="image-wrapper">
          <img
            src={blockedImage}
            alt="Blocked Section"
            className="blocked-image"
            style={{
              display: isLoading ? "none" : "block",
              opacity: isLoading ? 0 : 1,
              transition: "opacity 0.3s ease-in-out",
            }}
            onClick={handleBlockedImageClick}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
        </div>
      ) : (
        !isLoading && (
          <>
            <LoanRejectZet />
            {/* <div className="superLoanBoxfix status pb-18">
            <div className="imageSomeTimehere">
              <img
                src={imageSomeTime}
                height={25} 
                width={126}
                alt="personal loan"
              />
            </div>

          <div className="mt-3" style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <img
                height="28"
                width="28"
                src={PersonalLoan}
              style={{ flexShrink: 0, marginTop: '5px' }}
              />
              <div style={{ flex: 1 }}>
              <span className=" colouReject" style={{ 
                display: 'block', 
                textAlign: 'left',
                fontSize: '18px',
                fontWeight: '600',
                letterSpacing: '0em',
                marginBottom: '5px' 
              }}>
                  Loan Application Rejected!
                </span>
              <p className="spanText mbottom-10 align-start" style={{ margin: 0 }}>Following might be the reasons:</p>
              </div>
            </div>

            <div className="rightArrowBoxnew mb-3">
              <p className="spanText mbottom-10 align-start" style={{ fontWeight: '600' }}>Following might be the reasons:</p>

              <p className="sidePoint">
                <img height={12} width={12} src={imageArrow} />
                <span className="imageCredit"><span className="imageCreditcolour">Bureau: </span> Low credit score or credit history issues.</span>
              </p>

              <p className="sidePoint">
                <img height={12} width={12} src={imageArrow} />
                <span className="imageCredit"><span className="imageCreditcolour">Banking: </span> Income pattern doesn't align with policy.</span>
              </p>

              <p className="sidePoint">
                <img height={12} width={12} src={imageArrow} />
                <span className="imageCredit"><span className="imageCreditcolour">Policy: </span> Financial status doesn't meet criteria.</span>
              </p>
            </div>
          </div> */}
          </>
        )
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, {
  getBlockedSections,
  checkBlockedEligibility,
  cibilPullOnReeligibility,
  CreditAssist,
  notifyVisitorEvent,
  fetchProductsUrl,
})(LoanReject);
